import { Injectable } from "@angular/core";
import { OnboardingApi } from "../api/onboarding.api";
import { OnboardingTemplateType } from "../model/enum/onboarding-template-type.enum";

@Injectable()
export class OnboardingService {
    constructor(private onboardingApi: OnboardingApi) {}


    getTemplate = (type: OnboardingTemplateType = OnboardingTemplateType.Onboarding) =>
        this.onboardingApi.getTemplate(type);
    onboardUsers = (fileList: FileList) =>
        this.onboardingApi.onboardUsers(fileList);
}
